<script>

export default {
  inserted: (el) => {
    function loadImage() {
      const imageElement = el;

      if (imageElement) {
        // optional image loader here - we are not using this for now
        // imageElement.addEventListener("load", () => {
        //  setTimeout(() => el.classList.add("loaded"), 100);
        // });
        // imageElement.addEventListener("error", () => console.log("error"));
        imageElement.src = imageElement.dataset.src;
        imageElement.classList.remove('lazyloader');
      }
    }

    function handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function createObserver() {
      const options = {
        root: null,
        threshold: '0',
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }

    if (window.IntersectionObserver) {
      createObserver();
    } else {
      loadImage();
    }
  },

  bind: (el, binding) => {
    function addLazyClass() {
      if (el.nodeName !== 'IMG') {
        // directive not placed on image tag but probably another element with background image so we need to place the Lazy class
        el.classList.add('lazyloader');
        el.setAttribute('id', 'lazy-bg-image');
      }
      // this sometimes causes status type "Cancelled" on images. This is when the src is actually set on the images and we replace it with data-src
      else {
        // set either small 1 x 1 pixel image or loader image
        if (binding.modifiers.loader) {
          el.src = require('../assets/img/src/results/results_loader.gif');
        } else {
          el.src = require('../assets/img/src/results/Blank.jpg');
        }
      }
    }
    addLazyClass();
  },
};

</script>
